// removed by extract-text-webpack-plugin
module.exports = {"TrdFallBack":"TrdFallBack__-loca-___pjFG","Title":"TrdFallBack__-loca-__Azd0Z","UntilThen":"TrdFallBack__-loca-__NCuJO","CheckOutEtsy":"TrdFallBack__-loca-__i9xDO","CheckOutFacebook":"TrdFallBack__-loca-__26AwE","EtsyIcon":"TrdFallBack__-loca-__2goVF","FacebookIcon":"TrdFallBack__-loca-__3i1V2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TrdAdminFocus/TrdFallBack/TrdFallBack.css
// module id = 127
// module chunks = 0